module.exports = __webpack_public_path__ + "static/img/005.80fe7f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/005.png
// module id = rvrB
// module chunks = 1